import TapIcon from './tap-icon';
import AddIcon from './add-icon';

export default ({setStage}) => {
    return (
        <>
            <div className="a2hs-instruction">
                <div>
                    <b>1.</b> Tap <span><TapIcon /> Share</span> button at the bottom of your screen
                </div>
                <div>
                    <b>2.</b> Select <span><AddIcon /> Add to Home Screen</span>
                </div>
                <div>
                    <b>3.</b> Open the app and claim your bonus
                </div>
            </div>

            <div className="buttons">
                <div className="row">
                    <div className="button" onClick={e => setStage('ios-tutorial')}>
                        Watch Tutorial
                    </div>
                </div>
            </div>
        </>
    )
}